import React from 'react'
import { Status } from '@/types'
import { StepProgress, Step } from '@/components/ui/step-progress'

interface ReleaseStatusProgressProps {
  currentStatus: Status
  className?: string
}

// Define the main status steps in order of progression (excluding On Hold)
const MAIN_STATUS_STEPS: Step[] = [
  {
    id: 'not ready',
    label: 'Not Ready',
    description: 'Release is being prepared'
  },
  {
    id: 'ready for release',
    label: 'Ready',
    description: 'Ready to be released'
  },
  {
    id: 'released',
    label: 'Released',
    description: 'Live in production'
  }
]

// Define the On Hold step separately
const ON_HOLD_STEP: Step = {
  id: 'on hold',
  label: 'On Hold',
  description: 'Waiting for approval'
}

// Status colors for the step progress component - matching the new color scheme
const STATUS_COLORS = {
  'not ready': 'bg-amber-100 border-amber-100 text-[#f59e0b]', // release-not-ready
  'on hold': 'bg-red-100 border-red-100 text-[#ef4444]', // release-on-hold
  'ready for release': 'bg-blue-100 border-blue-100 text-[#3b82f6]', // release-ready
  'released': 'bg-emerald-100 border-emerald-100 text-[#10b981]' // release-released
}

export function ReleaseStatusProgress({ currentStatus, className }: ReleaseStatusProgressProps) {
  // Combine all steps for the vertical layout
  const allSteps = [...MAIN_STATUS_STEPS];
  
  // Add On Hold step if it's the current status
  if (currentStatus === 'on hold') {
    allSteps.unshift(ON_HOLD_STEP); // Add to the beginning
  }
  
  return (
    <div className={`${className} flex justify-center`}>
      <StepProgress 
        steps={allSteps} 
        currentStepId={currentStatus}
        statusColors={STATUS_COLORS}
      />
    </div>
  )
}

export default ReleaseStatusProgress
